import { render } from "./MarketplaceJobcategory.vue?vue&type=template&id=7c689c76&scoped=true"
import script from "./MarketplaceJobcategory.vue?vue&type=script&lang=js"
export * from "./MarketplaceJobcategory.vue?vue&type=script&lang=js"

import "./MarketplaceJobcategory.vue?vue&type=style&index=0&id=7c689c76&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c689c76"]])

export default __exports__